module.exports = __webpack_public_path__ + "img/nor_cha_throgg_0.17c816f7.png";